export function formatBytes(bytes: number): string {
  if (!bytes || bytes < 0) return ""
  const units = ["B", "KB", "MB", "GB", "TB"]
  let size = bytes
  let unitIndex = 0
  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024
    unitIndex += 1
  }
  const value = size % 1 === 0 ? size.toFixed(0) : size.toFixed(1)
  return `${value} ${units[unitIndex]}`
}

export function getReadableFileType(name?: string, mimeType?: string): string {
  const extension = (name || "").split(".").pop() || ""
  if (extension) return extension.toUpperCase()
  if (mimeType) {
    const main = mimeType.split("/")[0]
    return `${main.charAt(0).toUpperCase()}${main.slice(1)} file`
  }
  return ""
}
